<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Merk Barang</h5>
            </template>
            
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA UMUM</h6>
                    <b-form-group label="Jenis Barang">
                        <multiselect name="jenisBarang"
                            :value="jenisBarang.find(item => item.id == input.jenisBarang) || null"
                            :options="jenisBarang" :internal-search="true" :allow-empty="false"
                            deselect-label="" select-label="" label="name" track-by="id"
                            placeholder="Pilih Jenis Barang"
                            @input="input.jenisBarang = $event ? $event.id : null" />
                    </b-form-group>
                    <b-form-group label="Nama Merk Barang"
                    >
                        <b-form-input v-model="input.merkBarang" name="merkBarang" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">FILE PDF</h6>
                    <b-row>
                        <b-col cols="10" sm="3">
                            <FormulateForm v-model="pdf">
                                <FormulateInput
                                type="file"
                                name="file"
                                help="Format Harus PDF"
                                validation="mime:application/pdf"
                                accept=".pdf"
                                fileRemove
                                multiple
                                />
                            </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of input.filePDF">
                                <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                            </div>
                        </b-col>
                    </b-row> 
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">SPESIFIKASI</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addSpesifikasi" name="spesifikasiAddBtn"><i class="fa fa-plus mr-2"></i>Spesifikasi</b-button>
                        <Spesifikasi v-for="item in input.spesifikasi" v-bind:key="item.index"
                            :spesifikasi="item" :length="input.spesifikasi.length" @remove="removeSpesifikasi"
                            :filePDF = "item.filePDF"
                            :idSpesifikasi="item.id" 
                            @changeSESpek="changeSESpek"
                            @openModalPreviewPDFSpekKel = "openModalPreviewPDFSpekKel"
                        />
                    </div>
                </div>
                <!-- <div class="form-content-wrapper">
                    <h6 class="form-title">KONDISI</h6>
                    <label>Surat Edaran Kondisi Barang</label>
                    <b-row>
                        <b-col cols="10" sm="3">
                            <FormulateForm v-model="pdf1">
                                <FormulateInput
                                type="file"
                                name="file"
                                help="Format Harus PDF"
                                validation="mime:application/pdf"
                                accept=".pdf"
                                fileRemove
                                multiple
                                />
                            </FormulateForm>
                        </b-col>
                        <b-col cols="2">
                            <div v-for="file of input.filePDFKondisi">
                                <b-button v-if="file != null" size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF(file)">View</b-button>
                            </div>
                        </b-col>
                    </b-row> 
         
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addKondisi" name="kondisiAddBtn"><i class="fa fa-plus mr-2"></i>Kondisi</b-button>
                        <Kondisi v-for="item in input.kondisi" v-bind:key="item.index"
                            :kondisi="item" :length="input.kondisi.length" :isKendaraan="isKendaraan" @remove="removeKondisi"
                            :idKondisi="item.id" 
                            :filePDF = "item.filePDF"
                            @changeSEKon="changeSEKon"
                            @openModalPreviewPDFSpekKel = "openModalPreviewPDFSpekKel"
                        />
                    </div>
                </div> -->
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="merkBarangSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Merk Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput merk barang ini?" @submit="onSubmit" />
         <!-- MODAL SHOW SE -->
         <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
import { file } from '@babel/types';
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi';
import Kondisi from '../../../components/kondisi/Kondisi';
export default {
    name: 'input-merk-barang',
    components: { 
        Spesifikasi, Kondisi
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input:{
                merkBarang: "",
                jenisBarang: null,
                spesifikasi: [],
                kondisi: [
                    { 
                        index: 0, 
                        id: 0, 
                        name: "", 
                        dus: 0,
                        namaSendiri: 0,
                        detailInfo: "persen",
                        nominalPersen: null,
                        nominalAngka: null,
                        hargaMaksimal: 0
                    }
                ],
                filePDF: [],
                filePDFKondisi: [],
            },

            pdf: null,
            pdf1: null,
            activePdfPreview:null,

            jenisBarang: [],
            indexSpesifikasi: 0,
            indexKondisi: 1,
            isKendaraan: false
        }
    },
    
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getJenisBarang = this.$axios.get("barang-jenis/").then(response => {
                this.jenisBarang = response.data
            })

            Promise.all([getJenisBarang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        

        //----------------- Fungsi Tambah Hapus Data Spesifikasi & Kondisi -----------------

        addSpesifikasi() {
            this.input.spesifikasi.unshift({ 
                index: this.indexSpesifikasi, 
                id: 0, 
                name: "", 
                detailInfo: "persen", 
                nominalPersen: null, 
                nominalAngka: null,
                filePDF: []
            })
            this.indexSpesifikasi++;
        },

        removeSpesifikasi(index) {
            this.input.spesifikasi = this.input.spesifikasi.filter(item => item.index != index)
        },

        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0,
                filePDF: [],
                url : []
            })
            this.indexKondisi++;
        },

        removeKondisi(index) {
            this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            var status = ""
            let payload = new FormData()

            //----------------- Append Data Merk Barang -----------------

               //File PDF
        
               if( this.input.filePDF != null){
                for(var file of this.input.filePDF ){
                    payload.append("pdfFiles" , file)
                }
                }

                // if( this.input.filePDFKondisi != null){

                // let payloadKondisi = new FormData()
                // payloadKondisi.append("menu" , "kondisi0")
                // payloadKondisi.append("jenis" , "kondisi")
                // payload.append("pdfKondisi" , "kondisi0")

                // for(var file of this.input.filePDFKondisi ){
                //     payloadKondisi.append("pdfFiles" , file)
                // }

                // this.$axios.post("surat-edaran/insertOrUpdate/",payloadKondisi).then(response => {
                //         })
                //         .catch(error => {
                //             console.log(error)
                //             console.log(error.response.data.reason)
                //             this.$helper.parseError(this, error)
                //         })
                    
                // }

            if (this.input.spesifikasi.length != 0) {
                for (var x of this.input.spesifikasi) {
                    payload.append("spesifikasiId", 0)
                    payload.append("spesifikasiName", x.name)
                    if (x.detailInfo == "nominal") {
                        let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                        payload.append('spesifikasiNominalAngka', nominalAngka)
                        payload.append('spesifikasiNominalPersen', null)
                    } 
                    else {
                        payload.append('spesifikasiNominalPersen', x.nominalPersen)
                        payload.append('spesifikasiNominalAngka', null)
                    }

                    payload.append("pdfFilesSpesifikasi" , "spesifikasi"+x.id)
                    if(x.filePDF != null){
                        if( x.filePDF.length != 0){

                            let payloadSpesifikasi = new FormData()
                            payloadSpesifikasi.append("menu" , "spesifikasi"+x.id)
                            payloadSpesifikasi.append("jenis" , "spesifikasi")
                           
                            for(var file of x.filePDF){
                                payloadSpesifikasi.append("pdfFiles", file)   
                            }
                        
                            this.$axios.post("surat-edaran/insertOrUpdate/",payloadSpesifikasi).then(response => {
                            })
                            .catch(error => {
                                console.log(error)
                                console.log(error.response.data.reason)
                                this.$helper.parseError(this, error)
                            })
                        }
                       
                    }
                   
                }
            }

            // for (var x of this.input.kondisi) {
            //     payload.append('kondisiId', 0)
            //     payload.append('kondisiName', x.name)
            //     const nominalHargaMaks = this.$helper.removeThousandSeparator(x.hargaMaksimal);
            //     payload.append('kondisiHargaMaksimal', nominalHargaMaks)

            //     if(x.filePDF != null){
            //             for(var file of x.filePDF){
            //                 payload.append("pdfKondisi", file)
            //             }
            //         }

            //     if(this.isKendaraan == false){
            //         if (x.dus == 0) {
            //             status = true
            //         } 
            //         else {
            //             status = false
            //         }
            //         payload.append('kondisiDus', status)
            //     } 
            //     else {
            //         if (x.namaSendiri== 0) {
            //             status = true
            //         } 
            //         else {
            //             status = false
            //         }
            //         payload.append('kondisiNamaSendiri', status)
            //     }
            //     if (x.detailInfo == "nominal") {
            //         let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
            //         payload.append('kondisiNominalAngka', nominalAngka)
            //         payload.append('kondisiNominalPersen', null)
            //     } 
            //     else {
            //         payload.append('kondisiNominalPersen', x.nominalPersen)
            //         payload.append('kondisiNominalAngka', null)
            //     }
            // }

            payload.append("name", this.input.merkBarang)
            payload.append("jenisBarangId", this.input.jenisBarang)

            
            //----------------- Submit Semua Data -----------------
            this.isSubmitting = true
            
            this.$axios.post("barang-merk/", payload).then(response => {
                this.$helper.setFlash(`Merk barang baru telah berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/") + `/${response.data.id}`
                this.$router.push({ path })
               
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
           
            // if (this.input.kondisi.length == 0) {
            //     this.$helper.toastErr(this, "Tolong masukkan minimal 1 kondisi")
            //     return
            // } 

            if(this.input.filePDF != null){
                for(var file of this.input.filePDF){
                 
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }

            for( var spesifikasi of this.input.spesifikasi){
    
                if(spesifikasi.filePDF != null){
                    for(var file of spesifikasi.filePDF){
                       if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                        }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                  
                }
                }
                
            }

            //    for( var kondisi of this.input.kondisi){
            //     if(kondisi.filePDF != null){
            //         for(var file of kondisi.filePDF){
            //            if(file.type != null){
            //                 if(file.type != "application/pdf" ){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //             }else{
            //                 if(file.file.type != "application/pdf"){
            //                 this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
            //                 return
            //             }
            //         } 
                  
            //     }
            //     }
                
            // }

             this.$bvModal.show("modal-confirm-input")
        },

          //----------------- Fungsi SE -----------------
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

         //----------------- Fungsi SE Spesifikasi -----------------
         changeSESpek(idSpesifikasi,filePDF){
            let idx = this.input.spesifikasi.findIndex(item => item.id == idSpesifikasi)
            this.input.spesifikasi[idx].filePDF = filePDF
          
            
        },

        openModalPreviewPDF(pdf){
            this.toBase64(pdf).then(async base64 => {   
                this.activePdfPreview = base64
            })
            this.$bvModal.show("modal-SE")
        },

        openModalPreviewPDFSpekKel(base64){
            this.activePdfPreview = base64
            this.$bvModal.show("modal-SE")
        },

        changeSEKon(idKondisi,filePDF){
      
            let idx = this.input.kondisi.findIndex(item => item.id == idKondisi)
            this.input.kondisi[idx].filePDF = filePDF
        },

    },

    watch:{

        //----------------- Pantau Jenis Barang -----------------

        'input.jenisBarang': function(id){
            let jenis = this.jenisBarang.filter(item => item.id == id)
            let namaJenis = jenis[0].jenisPinjaman.name
            if (namaJenis == 'Kendaraan') {
                this.isKendaraan = true
            } 
            else if (namaJenis == 'Elektronik') {
                this.isKendaraan = false
            }
        },

        "pdf.file.files": function (newValue) {   
            let Pdfbase64 = []
            if(newValue.length != 0){
                for(var file of newValue){
                Pdfbase64.push(file.file)
                }
            this.input.filePDF = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDF = null
            }
        },

        "pdf1.file.files": function (newValue) {   
            let Pdfbase64 = []
            if(newValue.length != 0){
       
                for(var file of newValue){
                Pdfbase64.push(file.file)
                }
            this.input.filePDFKondisi = Pdfbase64
            }
            if(newValue.length == 0){
                this.input.filePDFKondisi = null
            }
        },

    },

    created(){
        this.init()
    }
}
</script>
